import { render, staticRenderFns } from "./ChangePhoneModal.vue?vue&type=template&id=2e5ed316&scoped=true&"
import script from "./ChangePhoneModal.vue?vue&type=script&lang=js&"
export * from "./ChangePhoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ed316",
  null
  
)

export default component.exports